module.exports = __webpack_public_path__ + "img/share_arrow.a8433b84.svg";